import { render, staticRenderFns } from "./Respostas.vue?vue&type=template&id=102aec58&scoped=true"
import script from "./Respostas.vue?vue&type=script&lang=js"
export * from "./Respostas.vue?vue&type=script&lang=js"
import style0 from "./Respostas.vue?vue&type=style&index=0&id=102aec58&prod&lang=css"
import style1 from "./Respostas.vue?vue&type=style&index=1&id=102aec58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102aec58",
  null
  
)

export default component.exports